module.exports = __webpack_public_path__ + "static/MT880.4e2238c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/MT880.png
// module id = 56
// module chunks = 21434532657768 117696030705815 145011745361637